import { defineMessages } from 'react-intl';

export const TIMESERIES_MESSAGES = defineMessages({
  zoomActionArrowUp: {
    defaultMessage: 'Up',
    id: '+MYvp4qc5Ti3ddoO',
    description:
      'Key shortcut in a tooltip shown when hovering the "Zoom in" action in the time series chart toolbar',
  },
  zoomActionArrowDown: {
    defaultMessage: 'Down',
    id: 'TKRQN9BIBeD8VT1I',
    description:
      'Key shortcut in a tooltip shown when hovering the "Zoom out" action in the time series chart toolbar',
  },
  zoomModeExplore: {
    id: 'TTCLEQtF7ylLxvEx',
    defaultMessage: 'Explore mode',
    description:
      'Text in a tooltip shown when hovering the "Explore" mode in the time series chart toolbar',
  },
  zoomModeZoom: {
    id: 'KlA+bTF6CnwSnbCJ',
    defaultMessage: 'Zoom mode',
    description:
      'Text in a tooltip shown when hovering the "Zoom" mode in the timeseries chart toolbar',
  },
  zoomModeZoomX: {
    id: 'VL8nEatHCgCkS4Yw',
    defaultMessage: 'X-axis zoom',
    description:
      'Text in a tooltip shown when hovering the "X-axis zoom" mode in the time series chart toolbar',
  },
  zoomModePan: {
    id: 'ntRg2/q/0hsoJ9+r',
    defaultMessage: 'Pan mode',
    description:
      'Text in a tooltip shown when hovering the "Pan" mode in the time series chart toolbar',
  },
  zoomActionZoomIn: {
    id: 'iN3ZVFNmBN0hzG0I',
    defaultMessage: 'Zoom in',
    description:
      'Text in a tooltip shown when hovering the "Zoom in" action in the time series chart toolbar',
  },
  zoomActionZoomOut: {
    id: 'arDem4VUr6iNJ1A3',
    defaultMessage: 'Zoom out',
    description:
      'Text in a tooltip shown when hovering the "Zoom out" action in the time series chart toolbar',
  },
  zoomActionReset: {
    id: '2zjArS0xoR2Fy4/o',
    defaultMessage: 'Reset',
    description:
      'Text in a tooltip shown when hovering the "Reset" action in the time series chart toolbar',
  },
  downloadAsCsv: {
    id: 'u5xmuzxNDovVbbQX',
    defaultMessage: 'Download as CSV',
    description:
      'Text in a tooltip shown when hovering the "Download data" button in the time series chart toolbar',
  },
});
